import React from "react";
import { createRoot } from 'react-dom/client';
import App from "./App";
import Modal from "react-modal";

Modal.setAppElement("#root");

window.onerror = function (message, source, lineno, colno, error) {
    console.error(`Global error occurred: ${message}`);
    window.location.href = '/pg/error';
    return true;
  };

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);